import { render, staticRenderFns } from "./BookingMessagesPage.vue?vue&type=template&id=fe7cc56c&scoped=true&"
import script from "./BookingMessagesPage.vue?vue&type=script&lang=ts&"
export * from "./BookingMessagesPage.vue?vue&type=script&lang=ts&"
import style0 from "./BookingMessagesPage.vue?vue&type=style&index=0&id=fe7cc56c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7cc56c",
  null
  
)

export default component.exports